import React, { useContext, createContext, useState, } from "react";
import { Api } from "./../../app-controller.js";

import { Redirect } from "react-router-dom";

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */

const authContext = createContext();

/**
 * ProvideAuth wraps all our authentication methods
 */
let sesion={};

export function ProvideAuth({ children }) {
  const [user, setUser] = useState(() => {
      if(localStorage.getItem("sesion")===null || localStorage.sesion ==="undefined" ){
          localStorage.removeItem("user");
          localStorage.removeItem("sesion");
          localStorage.removeItem("grupos");
          localStorage.removeItem("accesos");
          localStorage.removeItem("guidA");
          localStorage.removeItem("guidV");
          Redirect("/login"); 
          return {}; 
      }else{
        return JSON.parse(localStorage.sesion);
        let sesion = JSON.parse(localStorage.getItem("sesion"));
        if(sesion.email_verified_at===null){
          Redirect("/confirm"); 
        }else{
          Redirect("/login"); 
        } 
      }
    return JSON.parse(localStorage.sesion);
  });
  
  const login = (state) => {
    //call to function login in API
    Api.loading(1);
    return Api.fetch("auth/login", state, "POST")
      .then((data) => {
        //setting user and saving token and user to mantain session
        if(data==="false"){
          return;
        }
        setUser(data.user);
       


        localStorage.token = data.token;
        localStorage.user = JSON.stringify(data.user);
        localStorage.grupos =  JSON.stringify(data.grupos);
        localStorage.accesos =  JSON.stringify(data.accesos);
        localStorage.sesion = JSON.stringify(data.user);
        localStorage.guidA = data.guidA;
        localStorage.guidV = data.guidV;
        Api.user_profile = data.user;
        //email_verified();
        return data.user;
      });
  };

  const logout = () => {
    return Api.fetch("auth/logout", null, "POST")
      .then((data) => {
        localStorage.removeItem("user");
        localStorage.removeItem("sesion");
        localStorage.removeItem("grupos");
        localStorage.removeItem("accesos");
        localStorage.removeItem("guidA");
        localStorage.removeItem("guidV");
      });
  };

  const profile = () => {
    return Api.fetch("auth/profile", null, "POST")
      .then((data) => {
        return data;
      });
  }

  const checkUser = () => {
    return JSON.parse(localStorage.user);
  }

  const auth = { user, login, logout, profile,checkUser };

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

/** 
 * useAuth hook enables any component to get the current auth state and re-render if it changes.
**/

export function useAuth() {
  return useContext(authContext);
}

